<template>
	<div
		class="border-solid border border-gray-300 p-3"
		:style="`max-width: ${maxWidth != 0 ? maxWidth + 'px' : ''}`"
	>
		<slot></slot>
	</div>
</template>
<script>
export default {
	props: {
		maxWidth: {
			type: Number,
			default: 0
		}
	}
}
</script>
